var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5001_2438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9811 17.0814C15.0936 17.2127 15.2436 17.2689 15.3936 17.2689C15.5248 17.2689 15.6561 17.2314 15.7686 17.1189L18.0373 15.0377C18.1498 14.9252 18.2248 14.7752 18.2248 14.6252C18.2248 14.4752 18.1498 14.3064 18.0373 14.2127L15.7686 12.1314C15.5436 11.9252 15.1873 11.9439 14.9811 12.1689C14.7748 12.3939 14.7936 12.7502 15.0186 12.9564L16.8186 14.6064L15.0186 16.2564C14.7936 16.4814 14.7748 16.8377 14.9811 17.0814Z",
    fill: "#495464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2562 19.3127C10.3124 19.3315 10.3499 19.3502 10.4062 19.3502C10.6499 19.369 10.8937 19.2377 10.9874 18.994L14.0812 10.669C14.1937 10.369 14.0437 10.0502 13.7437 9.93774C13.4437 9.82524 13.1249 9.97524 13.0124 10.2752L9.9187 18.5815C9.8062 18.8815 9.9562 19.2002 10.2562 19.3127Z",
    fill: "#495464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.23115 17.1188C8.34365 17.2125 8.4749 17.2688 8.60615 17.2688C8.75615 17.2688 8.90615 17.2125 9.01865 17.0813C9.2249 16.8563 9.20615 16.5 8.98115 16.2938L7.18115 14.625L8.98115 12.975C9.20615 12.7688 9.2249 12.4125 9.01865 12.1875C8.8124 11.9625 8.45615 11.9438 8.23115 12.15L5.9624 14.2125C5.8499 14.325 5.7749 14.475 5.7749 14.625C5.7749 14.775 5.8499 14.9438 5.9624 15.0375L8.23115 17.1188Z",
    fill: "#495464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.625 23.8125H21.375C22.725 23.8125 23.8125 22.725 23.8125 21.375V2.625C23.8125 1.275 22.725 0.1875 21.375 0.1875H2.625C1.275 0.1875 0.1875 1.275 0.1875 2.625V5.25V21.375C0.1875 22.725 1.275 23.8125 2.625 23.8125ZM1.3125 2.625C1.3125 1.89375 1.89375 1.3125 2.625 1.3125H21.375C22.1063 1.3125 22.6875 1.89375 22.6875 2.625V5.4375H1.3125V2.625ZM1.3125 6.5625H22.6875V21.375C22.6875 22.1063 22.1063 22.6875 21.375 22.6875H2.625C1.89375 22.6875 1.3125 22.1063 1.3125 21.375V6.5625Z",
    fill: "#495464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.125 2.8125H3.375C3.05625 2.8125 2.8125 3.05625 2.8125 3.375C2.8125 3.69375 3.05625 3.9375 3.375 3.9375H4.125C4.44375 3.9375 4.6875 3.69375 4.6875 3.375C4.6875 3.05625 4.44375 2.8125 4.125 2.8125Z",
    fill: "#495464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.125 2.8125H6.375C6.05625 2.8125 5.8125 3.05625 5.8125 3.375C5.8125 3.69375 6.05625 3.9375 6.375 3.9375H7.125C7.44375 3.9375 7.6875 3.69375 7.6875 3.375C7.6875 3.05625 7.44375 2.8125 7.125 2.8125Z",
    fill: "#495464"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5001_2438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.f9c75d360c7c5f23ee07038ea3193c75.svg";
export { ForwardRef as ReactComponent };